import { cn } from "../ui/index.ts";
import { formatPatientDisplayName, patientNameParts } from "./patient-name.ts";

export function PatientNameDisplay({
  name,
  className,
  lastClassName,
  firstClassName,
}: {
  name: string;
  className?: string;
  lastClassName?: string;
  firstClassName?: string;
}) {
  const { first, last } = patientNameParts(name);

  if (!last) {
    return (
      <span className={cn("truncate font-semibold text-sf-text", className)}>
        {first}
      </span>
    );
  }

  return (
    <span
      className={cn("flex min-w-0 items-baseline gap-1.5 truncate", className)}
    >
      <span
        className={cn(
          "shrink-0 text-[12px] font-semibold uppercase tracking-wide text-sf-text-secondary",
          lastClassName,
        )}
      >
        {last}
      </span>
      <span
        className={cn(
          "truncate text-[14px] font-bold leading-tight text-sf-text",
          firstClassName,
        )}
      >
        {first}
      </span>
    </span>
  );
}

export { formatPatientDisplayName };
